export default function BetaDashboard() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Beta Dashboard</h2>
      <p>Coming soon...</p>
    </div>
  )
}
